import moment from 'moment';
import { get as getProduitUnitaire } from '@/api/produit/produitFace';
import { get as getProduitRegroupement } from '@/api/produit/produitReseau';
import getLiaisonTarifADate from '@/services/catalogue/getLiaisonTarifADate';
import { CATEGORIE_UNITAIRE, CATEGORIE_REGROUPEMENT, CATEGORIE_LOCATION } from '@/configuration/catalogue/produitConf';

function formatTarifFromLiaison(liaisonTarif) {
  if (!liaisonTarif) {
    return [];
  }
  const tarifs = [];
  tarifs.push(liaisonTarif);
  if (liaisonTarif.liaisonsTarif) {
    tarifs.push(...liaisonTarif.liaisonsTarif);
  }
  return tarifs;
}

function getLigneCommandeLocation(ligneCommandeRegoupement) {
  return ligneCommandeRegoupement.lignesCommande.find(i => {
    return i.typeProduit === CATEGORIE_LOCATION;
  });
}

export default async function getTarifPourDateLocation(ligneCommande) {
  let dateDebut = ligneCommande.dateDebut;
  let produit = {};
  if (ligneCommande.typeProduit === CATEGORIE_UNITAIRE) {
    produit = (await getProduitUnitaire(ligneCommande.produitId,
      ligneCommande.dateDebut)).data.result;
  } else if (ligneCommande.typeProduit === CATEGORIE_REGROUPEMENT) {
    produit = (await getProduitRegroupement(ligneCommande.produitId,
      ligneCommande.dateDebut)).data.result;
    const yearweek = (
      ligneCommande.ligneReseau.anneeSemaine.toString()
    );
    dateDebut = new Date(moment(yearweek, 'ggggww'));
  }
  const ligneCommandeLocation = getLigneCommandeLocation(ligneCommande);
  if (ligneCommandeLocation === null) {
    return [];
  }
  const liaisonTarif = getLiaisonTarifADate(produit,
    ligneCommandeLocation.produitId, dateDebut);
  return formatTarifFromLiaison(liaisonTarif);
}
